module.exports = __webpack_public_path__ + "img/icon-call-back.89fe1a1f.png";